import React from 'react'
import FilmSvg from '@/assets/svg/film.svg?react'

export type FilmIconProps = React.SVGProps<SVGSVGElement> & {
  title?: string
}

export function FilmIcon(props: FilmIconProps) {
  return (
    <FilmSvg {...props} />
  )
}

export default FilmIcon